<template>
  <footer class="w-full">
    <div class="footer-top bg-[#3b3b3b] py-4 md:py-5">
      <div class="w-full px-4 md:px-6 lg:container lg:mx-auto">
        <div class="flex flex-col lg:flex-row items-start justify-between gap-4 md:gap-6">
          <!-- 导航链接区域 -->
          <div class="w-full lg:w-auto">
            <div class="grid grid-cols-2 md:grid-cols-4 lg:flex lg:flex-wrap gap-3 md:gap-4">
              <ul class="w-ul text-[#c2c2c2]" v-for="(item, index) in navList" :key="index">
                <li class="text-[13px] md:text-[14px] font-semibold mb-2 md:mb-2.5 w-nav-first cursor-pointer text-white hover:text-[#DF0913] transition-colors flex items-center justify-between md:justify-start" 
                    @click="toggleSubMenu(index)">
                  <span @click.stop="navigateNavTo(item, index)">{{ item.name }}</span>
                  <span v-if="item.child && item.child.length > 0" 
                        class="md:hidden text-[#c2c2c2] ml-2 transition-transform duration-300"
                        :class="expandedMenus[index] ? 'rotate-180' : ''">
                    ▼
                  </span>
                </li>
                <li v-if="item.child && (expandedMenus[index] || windowWidth >= 768)"
                    class="submenu-container"
                    v-for="(child, i) in item.child" :key="i">
                  <span class="text-[11px] md:text-[12px] w-nav mb-1.5 cursor-pointer hover:text-white transition-colors block" 
                        @click="navigateTo(item, index, i, child)">
                    {{ child.name }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          
          <!-- 联系信息和二维码区域 -->
          <div class="w-full lg:w-auto flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-6">
            <!-- 联系信息 -->
            <div class="w-full md:w-auto">
              <h4 class="text-white text-[14px] md:text-[15px] font-semibold mb-3 text-center md:text-left">{{ $t('联系我们') }}</h4>
              <ul class="text-[#c2c2c2] text-[12px] md:text-[13px] space-y-2.5">
                <li class="w-info flex items-start justify-center md:justify-start">
                  <span class="text-white font-medium w-[50px] md:w-[60px] flex-shrink-0">{{ $t('邮箱：') }}</span>
                  <span class="hover:text-white transition-colors">{{ footInfo.web_site_email }}</span>
                </li>
                <li class="w-info flex items-start justify-center md:justify-start">
                  <span class="text-white font-medium w-[50px] md:w-[60px] flex-shrink-0">{{ $t('网址：') }}</span>
                  <span class="hover:text-white transition-colors break-all">{{ footInfo.store_web_site_domain }}</span>
                </li>
                <li class="w-info flex flex-col md:flex-row items-center md:items-start justify-center md:justify-start">
                  <span class="text-white font-medium w-[50px] md:w-[60px] flex-shrink-0 mb-1 md:mb-0">{{ $t('地址：') }}</span>
                  <div class="flex-1 flex-col w-address text-center md:text-left">
                    <p class="mb-0.5 last:mb-0" v-for="(item,index) in footInfo.web_site_address" :key="index">{{ item }}</p>
                  </div>
                </li>
              </ul>
            </div>
            
            <!-- 二维码 -->
            <div class="flex flex-col items-center justify-center mx-auto md:mx-0">
              <div class="bg-white p-1.5 rounded-lg shadow-lg">
                <img class="w-[75px] md:w-[90px]" :src="footInfo.qrcodeur" alt="二维码">
              </div>
              <p class="text-[#c2c2c2] text-[11px] md:text-[12px] mt-2 text-center">{{ $t('公众号二维码') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部版权信息 -->
    <div class="footer-bottom bg-[#242424] border-t border-[#3b3b3b]">
      <div class="w-full px-4 md:px-6 lg:container lg:mx-auto">
        <div class="flex flex-col md:flex-row items-center justify-between py-3 md:py-3.5 gap-2 md:gap-0">
          <div class="text-[#c2c2c2] text-[11px] md:text-[12px] text-center md:text-left">
            {{ footInfo.web_site_title }}
          </div>
          <div class="copyright text-[#999] text-[10px] md:text-[11px] text-center md:text-left">
            {{ footInfo.web_site_copyright }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { h, ref, reactive, computed, shallowRef, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { useStore } from 'vuex'
const store = useStore();
//取到state面的local
const local = computed(() => store.state.local);

const props = defineProps({
  navList: {
    type: Array,
    default() {
      return []
    }
  },
  footInfo: {
    type: Object,
    default() { }
  }
});

// 展开/收起状态
const expandedMenus = ref({})
const windowWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1024)

// 初始化菜单状态
const initMenuState = () => {
  if (windowWidth.value >= 768) {
    // 桌面端默认全部展开
    props.navList.forEach((_, index) => {
      expandedMenus.value[index] = true
    })
  } else {
    // 移动端默认全部收起
    props.navList.forEach((_, index) => {
      expandedMenus.value[index] = false
    })
  }
}

// 切换子菜单展开/收起
const toggleSubMenu = (index) => {
  if (windowWidth.value < 768) {
    expandedMenus.value[index] = !expandedMenus.value[index]
  }
}

// 监听窗口大小变化
const handleResize = () => {
  windowWidth.value = window.innerWidth
  // 根据窗口大小重新初始化菜单状态
  initMenuState()
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', handleResize)
    initMenuState() // 初始化
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', handleResize)
  }
})

const curIndex = computed({
  get: () => store.state.curIndex,
  set: (value) => store.commit('setCurIndex', value)
});

const onLanguage = (item) => {
  emits('on-language');
}

const subNavId = computed({
  get: () => store.state.childId,
  set: (value) => {
    store.commit('setSubNavId', value)
  }
})

//导航
const navigateNavTo = (item, index) => {
  curIndex.value = index;
  store.commit('setCurIndex', index);
  switch (index) {
    case 3:
      item.childId = 32
      break;
    case 4:
      item.childId = 45
      break;
    case 5:
      item.childId = 50
      break;
    case 6:
      item.childId = 54
      break;
  }
  store.commit('setSubNavId', item.childId);
  router.push({
    name: item.path,
    params: {
      pid: item.aid,
      name: item.name,
      aid: item.childId ? item.childId : item.aid
    }
  })
}

// 子导航
const navigateTo = (item, index, i, child) => {
  // console.log(item)
  // console.log(child)
  curIndex.value = index;
  store.commit('setCurIndex', index);
  subNavId.value = child.aid
  store.commit('setSubNavId', child.aid);
  router.push({
    name: child.path,
    params: {
      pid: item.aid,
      name: item.name,
      aid: child.aid
    } 
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer-top {
  // background-image: url('@/assets/images/h_9.png');
  background-size: 100% 300px;
}

.w-ul {
  min-width: 100px;
  
  @media (min-width: 768px) {
    min-width: 120px;
  }
  
  @media (min-width: 1024px) {
    min-width: 130px;
  }
}

.w-nav-first {
  line-height: 1.4;
  transition: color 0.3s ease;
}

.w-nav {
  line-height: 1.6;
  transition: color 0.3s ease;
  word-break: break-word;
  
  &:hover {
    color: #fff;
    transform: translateX(2px);
  }
}

.w-info {
  line-height: 1.6;
  
  span {
    transition: color 0.3s ease;
  }
}

.w-address {
  line-height: 1.5;
  
  p {
    margin-bottom: 2px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.footer-bottom {
  .copyright {
    line-height: 1.6;
  }
}

// 子菜单容器动画
.submenu-container {
  animation: slideFadeIn 0.3s ease-out;
}

@keyframes slideFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
  }
}

// 移动端优化
@media (max-width: 767px) {
  .w-ul {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>




